import { api } from './client.js';

export const documentsApi = {
  listForCar: (carId) => api(`/documents?car_id=${encodeURIComponent(carId)}`),
  get: (id) => api(`/documents/${id}`),
  create: (formData) => api('/documents', { method: 'POST', form: formData }),
  update: (id, body) => api(`/documents/${id}`, { method: 'PATCH', body }),
  remove: (id) => api(`/documents/${id}`, { method: 'DELETE' }),
  renew: (id, formData) => api(`/documents/${id}/renew`, { method: 'POST', form: formData }),
  fileUrl: (id) => `/api/files/documents/${id}`,
};

export const DOCUMENT_TYPES = [
  { value: 'RCA', label: 'RCA' },
  { value: 'CASCO', label: 'CASCO' },
  { value: 'ITP', label: 'ITP' },
  { value: 'rovinieta', label: 'Rovinietă' },
  { value: 'talon', label: 'Talon' },
  { value: 'carte_auto', label: 'Carte auto' },
  { value: 'altele', label: 'Altele' },
];

export function documentLabel(tip) {
  return DOCUMENT_TYPES.find((t) => t.value === tip)?.label || tip;
}
